import React from "react"

import { useSelector } from "react-redux"
import Info from "../../../version.json"
import EAccomIARC from "../../../assets/img/eaccom-iarc.png"

export default function FooterBooking() {
  const system = useSelector((state) => state.system)
  if (system && system.isLoading === true)
    return (
      <>
        <footer className="block py-4">
          <div className="container mx-auto px-4">
            <hr className="mb-4 border-b-1 border-gray-300" />
            <div className="flex flex-wrap items-center md:justify-between justify-center">
              <div className="w-full md:w-4/12 px-4">
                <div className="text-sm text-gray-600 font-semibold py-1 text-center md:text-left">
                  © {new Date().getFullYear()} {system?.systemOwner}
                </div>
                <div className="text-xs text-gray-600 font-semibold py-1 text-center md:text-left">
                  Powered By
                  <a
                    href="https://iarc.psu.ac.th/"
                    className="text-gray-600 hover:text-gray-800  font-semibold py-1"
                  >
                    {" "}
                    IARC-PSU
                  </a>{" "}
                  <br />
                  <span className="text-xs">E-Accom Ver. {Info.version}</span>
                </div>
              </div>
              {system.systemSponsor && (
                <div className="w-full md:w-8/12 px-4 flex justify-end">
                  <div className="text-sm text-gray-600 font-semibold py-1 text-center md:text-left">
                    Supported By{" "}
                    <a
                      href={system.systemSponsorURL}
                      className="text-gray-600 hover:text-gray-800 text-sm font-semibold py-1"
                    >
                      {system.systemSponsor}
                    </a>{" "}
                  </div>
                </div>
              )}
            </div>
          </div>
        </footer>
      </>
    )

  return <></>
}
